import { IconButton, Theme, Tooltip, Typography, withStyles } from "@material-ui/core";
import React from "react";
import InfoIcon from '@material-ui/icons/Info';

interface HtmlTooltipProps {
  message: string;
  title?: string;
}

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

export default function TooltipHtml(props: HtmlTooltipProps) {
  return (
    <div style={{ margin: "-5px", paddingLeft: "9px" }}>
      <HtmlTooltip
        title={
          <React.Fragment>
            {props.title === undefined ?
              <Typography color="inherit">Atenção:</Typography>
              : <Typography color="inherit">{props.title}</Typography>}
            
            <b style={{ fontSize: "0.9rem" }}>{props.message}</b>
          </React.Fragment>
        }>
        <IconButton size="small" style={{ color: "orange" }}>
          <InfoIcon fontSize="inherit" />
        </IconButton>
      </HtmlTooltip>
    </div>
  );
}